import { useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useDeepCompareEffect } from 'react-use';
import { isNull } from 'lodash';

import {
   Anchor,
   AnchorAlignment,
   ContentNode,
   Notification,
   NotificationSize,
   NotificationType,
} from '@dreryk/react-components';

import { useRef } from '~libs.ui.react';

import { AppointmentFormController } from '../AppointmentForm.types';
import { ReceptionServiceTableBean } from '../../../../../receptionService/extensions/calendar/appointment/interactiveTable/ReceptionServiceInteractiveTable.types';

import { getTotalAdvancePayment, getWarningMessage } from './AdvancePaymentMayRequiredAnAdditionalPaymentWarning.utils';

type AdvancePaymentMayRequiredAnAdditionalPaymentWarningProps = Pick<AppointmentFormController, 'watch' | 'control'>;

export const AdvancePaymentMayRequiredAnAdditionalPaymentWarning = (
   props: AdvancePaymentMayRequiredAnAdditionalPaymentWarningProps
): JSX.Element | null => {
   const [warningMessage, setWarningMessage] = useState<ContentNode | null>(null);
   const formValues = props.watch();
   const { current: previousReceptionServiceValue } = useRef<ReceptionServiceTableBean[]>(
      formValues.receptionService?.value ?? []
   );
   const receptionServiceValue = useWatch<ReceptionServiceTableBean[]>({
      name: 'receptionService.value',
      control: props.control,
      defaultValue: previousReceptionServiceValue,
   });

   useDeepCompareEffect(() => {
      const previousTotalAdvancePayment = getTotalAdvancePayment(previousReceptionServiceValue);
      const currentTotalAdvancePayment = getTotalAdvancePayment(receptionServiceValue);
      setWarningMessage(getWarningMessage(previousTotalAdvancePayment, currentTotalAdvancePayment));
   }, [receptionServiceValue]);

   if (isNull(warningMessage)) {
      return null;
   }

   return (
      <Anchor
         shouldPerformScroll
         verticalAlignment={AnchorAlignment.END}
         testId={'advancePaymentMayRequiredAnAdditionalPaymentWarning'}
      >
         <Notification
            testId={'advancePaymentMayRequiredAnAdditionalPaymentWarning'}
            type={NotificationType.WARNING}
            size={NotificationSize.SMALLER}
            label={warningMessage}
         />
      </Anchor>
   );
};
